import React from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListDeviceLoginDenialSummary } from '../../../../../api-new/state/auth'
import { ColumnDateTime, ColumnText } from '../../../../../shared/table-builder/table-columns'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { IconAuthLogin } from '../../../../../shared/icon/icon'
import { SECTION } from '../../../../../shared/navigation/sections'

// Refused sign-ins grouped by the address that ASKED for the code.
//
// This is the view a decision would rest on, so it is built to make one
// particular mistake hard.
//
// "Explicit" is separated from "dismissed" and "unspecified" because only an
// explicit refusal is evidence about the requester, and a total that folded the
// others in would be the number someone acted on.
//
// "Known accounts" is how many accounts have signed in successfully from this
// same address recently, and it is on this screen rather than a detail view
// because it is the number that changes the answer. A high denial count from an
// address with no history is a sweeper. The same count from an address with
// twenty accounts behind it is one bad actor on a school or office network, and
// restricting that address takes everyone on it offline. Those want opposite
// responses, and the denial count alone cannot tell them apart.
export const DeviceLoginDenialSummary = () => {
  const apiList = useApiListDeviceLoginDenialSummary()

  const handleReady = async () => await apiList.get()
  const handleDestroyed = () => apiList.init()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={SECTION.refusedSignIns.Icon} text={SECTION.refusedSignIns.text}>
        <CardFullHeightScrollY title="refused sign-ins by requesting address (last 24h)">
          <TableAgClient
            apiList={apiList}
            onReady={handleReady}
            onDestoryed={handleDestroyed}
            emptyState={{ Icon: IconAuthLogin, title: 'No refused sign-ins', message: 'Sign-ins refused by an organization\'s sign-in rules appear here.' }}>
            <ColumnText field="ipAddress" header="Requester IP" />
            <ColumnText field="ipLocation" header="Location" />
            <ColumnText field="explicitDenials" header="Explicit refusals" />
            <ColumnText field="dismissedDenials" header="Dismissed" />
            <ColumnText field="unspecifiedDenials" header="Unspecified" />
            <ColumnText field="knownAccounts" header="Known accounts here" />
            <ColumnText field="distinctClients" header="Distinct devices" />
            <ColumnText field="distinctApprovers" header="Distinct approvers" />
            <ColumnDateTime field="firstSeen" header="First seen" />
            <ColumnDateTime field="lastSeen" header="Last seen" />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
